module.exports = __webpack_public_path__ + "static/media/code.75ca48cf.jpg";